<template>
  <sys-data-table
    v-model="TIPOS_PROJECAO_VENDAS_SELECIONADAS_COMPUTED"
    :headers="CABECALHOS_COMPUTED"
    :items="tipos_projecao_vendas"
    hide-default-footer
    :height="props.height"
    :item-height="60"
    :show-select="props.ativar_multi_selecao"
    :item-class="classesCssLinha"
  >
    <template #item.descricao="{ item }">
      <div :class="{'font-weight-regular': !item.aplicado , 'font-weight-medium': item.aplicado}">
        <div class="d-flex justify-space-between align-center">
          {{ item.descricao }}

          <span
            v-if="item.aplicado"
            style="color: #0CB935; background-color: #E6FBEB; padding: 1px 10px;"
            class="font-12 bra-15"
          >
            <v-icon color="#0CB935" size="18">$Lightning</v-icon>
            Atual aplicado
          </span>
        </div>
      </div>
    </template>

    <template #item.valor="{ item }">
      <template v-if="EMBALAGEM_MASTER_ATIVA_COMPUTED">
        <template v-if="props.tipo_fator_conversao === 'D'">
          {{ formatarValorComCasas(item.valor / props.multiplo_compra, 4) }}
        </template>

        <template v-else>
          {{ formatarValorComCasas(item.valor * props.multiplo_compra, 4) }}
        </template>
      </template>

      <template v-else>
        {{ formatarValorComCasas(item.valor, 4) }}
      </template>
    </template>

    <template #item.erro="{ item }">
      {{ item.erros ? formatarValorComCasas(item.erros.media_erro_quadratrico, 0) : '-' }}
    </template>

    <template #item.acoes="{ item }">
      <div class="d-flex align-center justify-end">
        <Simulacao
          v-if="item.simulavel"
          :produto="props.produto"
          :index_tipos_projecao_vendas_inicial="item.index"
        />

        <CompraSazonal
          v-if="item.index === 'media_sazonal'"
          :produto="props.produto"
          :influencia_aplicada="item.index === 'media_sazonal' && item.aplicado"
          @aplicar-compra-sazonal="aplicadaProjecaoMediaSazonal"
        />

        <AplicarTipoProjecao
          v-else
          :produto="props.produto"
          :index_tipo_projecao_vendas="item.index"
          @update:tipo-projecao-aplicado="ev => aplicarProjecaoVenda(ev)"
          @update:projecao-media-sazonal-aplicado="aplicadaProjecaoMediaSazonal"
        />
      </div>
    </template>
  </sys-data-table>
</template>

<script setup>
import {computed, onMounted, ref} from "vue";
import {formatarValorComCasas, logout} from "@/helpers";

import api from "@/api/api";
import store from "@/store/index";
import Simulacao from "@/components/produto/detalhes/ProjecaoVenda/Parametrizacao/Simulacao/Index.vue";
import AplicarTipoProjecao from "@/components/produto/detalhes/ProjecaoVenda/Parametrizacao/AplicacaoTipoProjecao/Index.vue";
import CompraSazonal from "@/components/produto/detalhes/ProjecaoVenda/Parametrizacao/AplicacaoTipoProjecao/CompraSazonal/Index.vue";
import { toast2 } from "@/components/utils/ui_v4/alerts/toast/toast2";

const props = defineProps({
  produto: Object,
  ativar_multi_selecao: Boolean,
  index_tipos_projecao_vendas_inicial: String,
  tipos_projecao_vendas_selecionados: Array,
  indexs_tipos_projecao_vendas_para_ocultar: {
    type: Array,
    default: () => ([]),
  },
  height: {
    type: Number,
    default: 410,
  },
  tipo_fator_conversao: {
    type: String,
    default: 'D'
  },
  multiplo_compra: {
    type: Number,
    default: 1
  }
});

const emit = defineEmits(['update:tipos_projecao_vendas_selecionados', 'update:tipo-projecao-aplicado', 'ir-para-tela-de-compras']);

const dialog_ativo = ref(!false);

const cabecalhos = [
  { text: 'Projeção de Vendas (30 dias)', value: 'descricao', style: { fontSize: '13px', fontWeight: '500' } },
  { text: 'Projeção', value: 'valor', style: { textAlign: 'center' } },
  { text: 'Erro', value: 'erro', style: { textAlign: 'center' } },
  { text: '', value: 'acoes', visao_sem_multi_selecao: true, style: { textAlign: 'center' } },
];

const EMBALAGEM_MASTER_ATIVA_COMPUTED = computed(() => {
  return store.getters["EmbalagemTelaDeCompras/getEmbalagemMaster"];
})

const CABECALHOS_COMPUTED = computed(() => {
  if (!props.ativar_multi_selecao) {
    return cabecalhos;
  }

  return cabecalhos.filter(c => !c.visao_sem_multi_selecao);
});

const TIPOS_PROJECAO_VENDAS_SELECIONADAS_COMPUTED = computed({
  get: () => props.tipos_projecao_vendas_selecionados || [],
  set: valor => emit('update:tipos_projecao_vendas_selecionados', valor),
});

onMounted(buscarTiposProjecaoVendasAtual);

const tipos_projecao_vendas = ref([]);

function buscarTiposProjecaoVendasAtual() {
  const params = {
    ...props.produto,
    produto_eh_combinacao: props.produto.produto_eh_combinacao ? 'S' : 'N',
  };

  api.get('produtos/projecao-vendas/parametrizacao/tipos-projecoes/atual', { params })
    .then(resposta => {
      if (props.indexs_tipos_projecao_vendas_para_ocultar.length > 0) {
        tipos_projecao_vendas.value = resposta.data.projecoes.filter(item => !props.indexs_tipos_projecao_vendas_para_ocultar.includes(item.index));
      } else {
        tipos_projecao_vendas.value = resposta.data.projecoes;
      }

      selecionarTipoProjecaoInicial();
    })
    .catch(logout)
}

function selecionarTipoProjecaoInicial() {
  if (!props.index_tipos_projecao_vendas_inicial) return;

  TIPOS_PROJECAO_VENDAS_SELECIONADAS_COMPUTED.value = tipos_projecao_vendas
    .value.filter(item => item.index === props.index_tipos_projecao_vendas_inicial);
}

function classesCssLinha(linha) {
  return {
    'text-gray-300': 1 === 1
  };
}

function aplicarProjecaoVenda(ev) {
  emit('update:tipo-projecao-aplicado', ev);
  toast2.success("Projeção aplicada com sucesso!");
}

function aplicadaProjecaoMediaSazonal(ev) {
  emit('update:tipo-projecao-aplicado', ev);

  tipos_projecao_vendas.value.forEach(item => {
    item.aplicado = item.index === 'media_sazonal';
  });
}
</script>
